import { createSlice } from '@reduxjs/toolkit'

const assetRegisterFilterSlice = createSlice({
  name: 'assetRegisterFilters',
  initialState: {},
  reducers: {
    setAssetRegisterFilter: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    clearAssetRegisterFiltersButKeepSort: (state: {
      sort?: [{ fields: string; dir: string }]
      searchTerm?: string
    }) => {
      const nextState: {
        sort?: [{ fields: string; dir: string }]
        searchTerm?: string
      } = {}

      if (state.sort) {
        nextState.sort = state.sort
      }

      if (state.searchTerm) {
        nextState.searchTerm = state.searchTerm
      }

      return nextState
    },
    setAssetRegisterSort: (state, action) => {
      const { field, dir } = action.payload
      return {
        ...state,
        sort: [
          {
            field,
            dir,
          },
        ],
      }
    },
    clearAssetRegisterSort: (state: { sort?: [{ fiels: string; dir: string }] }) => {
      const { sort, ...rest } = state
      return rest
    },
    setAssetRegisterSearchTerm: (state, action) => {
      return {
        ...state,
        searchTerm: action.payload,
      }
    },
    clearAssetRegisterSearchTerm: state => {
      const { searchTerm, ...rest }: { searchTerm?: string } = state
      return rest
    },
  },
})

export const {
  setAssetRegisterFilter,
  clearAssetRegisterFiltersButKeepSort,
  setAssetRegisterSort,
  clearAssetRegisterSort,
  setAssetRegisterSearchTerm,
  clearAssetRegisterSearchTerm,
} = assetRegisterFilterSlice.actions

export default assetRegisterFilterSlice.reducer
